exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger-box[data-v-33ec43fc]{\n  height: 54px;\n}\n", ""]);

// exports
